import BaseType from "../BaseType";
import SchoolDemographicResponseItem from "./SchoolDemographicResponseItem";

export default class SchoolDemographicResponseHeader extends BaseType {
  Items: SchoolDemographicResponseItem[] = [];
}
